module.exports = __webpack_public_path__ + "img/target_investment.40f46036.svg";